import { ActionTakenType, DocumentTemplateType } from '../../../api-client/autogenerated';
import {
  ActionTakenLabelOverrides,
  DisabledActionTakenTypes,
  getCustomActionTakenLabel,
  isActionTakenEnabled,
} from '../../../scripts/action-taken-labels';

/**
 * The actions a submittal review can recommend (the standard ones, in the order ReviewAndReturn
 * offers them), worded the way the subscriber words them and without the ones it switched off.
 */

export interface ActionOption {
  action: ActionTakenType;
  label: string;
}

const STANDARD: ActionOption[] = [
  { action: ActionTakenType.NoExceptionsTaken, label: 'No Exceptions Taken' },
  { action: ActionTakenType.AmendAsNoted, label: 'Amend As Noted' },
  { action: ActionTakenType.ReviseAndResubmit, label: 'Revise & Resubmit' },
  { action: ActionTakenType.Rejected, label: 'Rejected' },
  { action: ActionTakenType.SubmitSpecifiedItem, label: 'Submit Specified Item' },
];

export function submittalActionOptions(
  labels: ActionTakenLabelOverrides,
  disabled: DisabledActionTakenTypes,
  docType: DocumentTemplateType | null | undefined,
): ActionOption[] {
  return STANDARD.filter(({ action }) => isActionTakenEnabled(action, disabled, docType)).map(
    ({ action, label }) => ({
      action,
      label: getCustomActionTakenLabel(action, labels, docType) ?? label,
    }),
  );
}
